<script setup lang="ts">
import WebInput from '~/components/Common/Form/web/web-input.vue'
import IonicInput from '~/components/Common/Form/ionic/ionic-input.vue'

const model = defineModel()
defineProps<{
	name?: string
	type?: 'date'
			| 'email'
			| 'number'
			| 'password'
			| 'search'
			| 'tel'
			| 'text'
			| 'url'
			| 'time'
			| 'week'
			| 'month'
			| 'datetime-local'
	label?: string
	labelPosition?: "stacked" | "floating" | "fixed" | undefined
	placeholder?: string
	error?: string
	disabled?: boolean
}>()

const emits = defineEmits(['blur'])

</script>

<template>
	<component
				:is="useRenderingMode().isMobileApp ? IonicInput : WebInput"
				:name="name"
				:type="type"
				v-model="model"
				:placeholder="placeholder"
				:labelPosition="labelPosition"
				:label="label"
				:disabled="disabled"
				@blur="emits('blur')"
			/>

			<div v-if="error" class="text-red-600 text-sm mt-1">
			{{ error }}
		</div>
</template>

